export default "__VITE_ASSET__BqE9MDtT__"